export const SET_PREFERENCES_ACTION = 'SET_PREFERENCES_ACTION';
export const SET_PREFERENCES_SUCCESS_ACTION = 'SET_PREFERENCES_SUCCESS_ACTION';
export const SET_PREFERENCES_FAILURE_ACTION = 'SET_PREFERENCES_FAILURE_ACTION';
